var map = {
	"./Home.vue": [
		"bb51",
		"chunk-2d21a3d2"
	],
	"./areas/areaCarreras.vue": [
		"1379",
		"chunk-0d6cd2f9",
		"chunk-2d0aad7a"
	],
	"./areas/areaCarrerasSede.vue": [
		"0b21",
		"chunk-0d6cd2f9",
		"chunk-2d0ae8e7"
	],
	"./areas/index.vue": [
		"c533",
		"chunk-2d216f08"
	],
	"./carreras/Carreras.vue": [
		"c81e",
		"chunk-2d217a3f"
	],
	"./ponderables/index.vue": [
		"222b",
		"chunk-2d0b1da6"
	],
	"./solicitud_informaciones/index.vue": [
		"3339",
		"chunk-e9e2ad04"
	],
	"./template/About.vue": [
		"3229",
		"chunk-2d0b91dc"
	],
	"./template/Dashboard.vue": [
		"ff3a",
		"chunk-d59134ce"
	],
	"./template/Icons.vue": [
		"c70d",
		"chunk-2d21765e"
	],
	"./template/Maps.vue": [
		"6da7",
		"chunk-4fc7d494"
	],
	"./template/Notifications.vue": [
		"04cc",
		"chunk-3ccd6eac"
	],
	"./template/TableList.vue": [
		"8852",
		"chunk-2d0dee93"
	],
	"./template/Typography.vue": [
		"e496",
		"chunk-6af4faeb"
	],
	"./template/Upgrade.vue": [
		"fee8",
		"chunk-2d238668"
	],
	"./template/UserProfile.vue": [
		"dd22",
		"chunk-1312a6ad"
	],
	"./universidad_recomendadas/UniversidadRecomendadas.vue": [
		"01f8",
		"chunk-2d0a3749"
	],
	"./universidades/carreraSede.vue": [
		"98a9",
		"chunk-3a2cc78f"
	],
	"./universidades/carreraSedes.vue": [
		"0e27",
		"chunk-0d6cd2f9",
		"chunk-544ddac7"
	],
	"./universidades/index.vue": [
		"e0e5",
		"chunk-2d224b11"
	],
	"./universidades/sedes.vue": [
		"ed32",
		"chunk-2d230834"
	],
	"./usuarios/Login.vue": [
		"912e",
		"chunk-ebd88f08"
	],
	"./usuarios/Registro.vue": [
		"2e26",
		"chunk-45be0790"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;